import Vue from 'vue';

Vue.component(
    'model-slider-section-with-features',
    () => import('../async-components/async-slider-section-with-features'),
);
